import { motion } from "framer-motion";

type TestimonialProps = {
  quote: string;
  author: string;
  role: string;
  avatar: string;
};

export const TestimonialBlock = ({
  quote,
  author,
  role,
  avatar,
}: TestimonialProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.3 }}
      className="py-20"
    >
      <div className="mx-auto max-w-4xl px-4 text-center">
        {/* Quote mark */}
        <div className="text-8xl text-white/40 mb-4">“</div>

        {/* Main quote */}
        <p className="text-2xl sm:text-3xl md:text-4xl font-light text-white/90 leading-[1.4]">
          {quote}
        </p>

        {/* Author */}
        <div className="mt-10 flex items-center justify-center gap-4">
          <img
            src={avatar}
            alt={author}
            className="w-14 h-14 rounded-full object-cover border border-white/10"
          />
          <div className="text-left">
            <div className="font-semibold text-white/90">{author}</div>
            <div className="text-white/50 text-sm">{role}</div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
